var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptySeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_27356_186865)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "url(#paint0_linear_27356_186865)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 14C25.5523 14 26 14.4477 26 15V24.3108C26 25.2206 27.1164 25.6577 27.7342 24.9897L29.3598 23.2318C29.7841 22.8782 30.4147 22.9356 30.7682 23.3598C31.1218 23.7841 31.0645 24.4147 30.6402 24.7682L25.6402 29.7682L25.6247 29.7809C25.4685 29.9061 25.2738 29.9853 25.0613 29.9982C25.0205 30.0006 24.9796 30.0007 24.9388 29.9982C24.7169 29.9848 24.5146 29.899 24.3551 29.7643L19.3598 24.7682C18.9356 24.4147 18.8782 23.7841 19.2318 23.3598C19.5854 22.9356 20.2159 22.8782 20.6402 23.2318L22.2658 24.9897C22.8836 25.6577 24 25.2206 24 24.3107V15C24 14.4477 24.4477 14 25 14Z",
    fill: "url(#paint1_linear_27356_186865)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 34C16.4477 34 16 34.4477 16 35C16 35.5523 16.4477 36 17 36H33C33.5523 36 34 35.5523 34 35C34 34.4477 33.5523 34 33 34H17Z",
    fill: "url(#paint2_linear_27356_186865)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_27356_186865",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_27356_186865"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_27356_186865"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27356_186865",
    x1: 25,
    y1: 0,
    x2: 25,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#28282C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_27356_186865",
    x1: 25,
    y1: 16.8,
    x2: 25.8532,
    y2: 43.1966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6C6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_27356_186865",
    x1: 25,
    y1: 16.8,
    x2: 25.8532,
    y2: 43.1966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6C6C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySeat);
export default __webpack_public_path__ + "static/media/EmptySeat.f9955a569f570e166ba06db03ac5e3ba.svg";
export { ForwardRef as ReactComponent };